jQuery.widget("bluaul.Activities", jQuery.common.vcBaseV4, {
    // <summary>
    /// This widget is used to manage activities, including a list view and a day view.
    /// It allows users to add, edit, and view activities in different formats.
    /// </summary>

    vcV: new vcVisual(),
    vcC: new vcCommon(),

    myStatus: {
        selectedMode: "list", // can be "list", "dayview" or "edit"
        dateStart: null,
        dateEnd: null,
        interval: 1, // default interval
        allActivities: [],
        allDailyActivities: [],
        editMode: false,
        shared: {
            lastDescription: "",
            lastActivity: null 
        },


    },

    _create: function () {
        var me = this;
        // deep copy of myStatus to avoid reference issues if more than one instance of Activities widget is created
        me.myStatus = $.extend(true, {}, me.myStatus);
        me._createVisual(394);
        me._super();
    },

    _initHTML: function () {
        /// <summary>
        /// This function initializes the HTML structure for the Activity Input widget.
        /// It sets up the top menu and content area, and initializes the activity list and day view.
        /// </summary>

        var me = this;
        try {
            me._setRoot(".activity-input");

            // deep copy of flags to avoid reference issues if more than one instance of Activities widget is created
            me.flags = $.extend(true, {}, me.specific.widgetFlags || {});

            // build whole html structure
            me._buildHtml();   

            // we set the selected mode before initializing all views (to get correct initial data from DB)
            me.myStatus.selectedMode = me.flags.StartWithOverview ? "dayview" : "list";
            me._setHeights();
            
            objActivityList._initializeObjActivityList(me);
            objActivityDayView._initializeObjActivityDayView(me);
            objActivityEdit._initializeObjActivityEdit(me);                    

            me._setInitialStatus();

            

            return true;
        } catch (e) { me.writeError('_initHTML', e); return false; }
    },


    _initEvents: function () {
        /// <summary>
        /// This function initializes all events for the Activity Input widget.
        /// It sets up event handlers for the top menu buttons to toggle between list and day view.
        /// </summary>

        var me = this;
        try {

            me.myHtml.topmenu.find("#btn-dayview").on("click", function () {
                me._toggleMenuButtons("dayview");
            });

            me.myHtml.topmenu.find("#btn-list").on("click", function () {
                me._toggleMenuButtons("list");
            });

        } catch (e) { me._writeErr(e); }
    },

    _setInitialStatus: function () {
        /// <summary>
        /// This function sets the initial status of the widget based on the start mode.
        /// It determines whether to show the list view or the day view based on the configuration.
        /// </summary>

        var me = this;

        var mode = me.myStatus.selectedMode;
        var showOverview = me.flags.ShowOverview;
        if (!showOverview) {
            me.myHtml.topmenu.find("#btn-dayview").hide();
            me.myHtml.topmenu.hide();
        }

        me.myHtml.topmenu.find("#btn-dayview").toggleClass("button-toggle-active", mode === "dayview");
        me.myHtml.topmenu.find("#btn-list").toggleClass("button-toggle-active", mode === "list");

        
        me.myStatus.interval = (mode === "dayview") ? 1 : 3;
        me.myHtml.activityEdit.hide();

        if (mode === "list") {
            me.myHtml.activityList.show();
            me.myHtml.activityDayview.hide();             
        }
        else {
            me.myHtml.activityList.hide();
            me.myHtml.activityDayview.show();
        }
    },


    _buildHtml: function () {
        /// <summary>
        /// builds up the main structure
        /// </summary>
        var me = this;
        try {
            me.myHtml = {
                topmenu: {}, content: {} };

            // top menu
            me.myHtml.topmenu = me._setObj("div-topmenu", "vc-grid-margin-right float vc-grid-margin-bottom");
            let obj = me.myHtml.topmenu;
            obj.width(me.myRoot.width());

            // top menu buttons
            obj.btnDayview = me._setObj("btn-dayview", "button-toggle").data("mode", "dayview").html(me.specific.resources.overview).css("width", "100px").button();
            obj.btnList = me._setObj("btn-list", "button-toggle button-toggle-active").data("mode", "list").html(me.specific.resources.list).css("width", "100px").button();
            obj.append(obj.btnDayview, obj.btnList);

            // separation line
            obj.append($("<hr>").css({ width: "100%", border: "none", borderTop: "1px solid #ccc", margin: "2px 0" }));

            me.myHtml.content = me._setObj("div-content", "vc-grid-margin-right float").css("width", "100%").css("height", "100%");            

            me.myRoot.append(me.myHtml.topmenu, me.myHtml.content);

        } catch (e) { me.writeError('_buildHtml', e); return false; }
        return true;
    },

    _setHeights: function () {
        var me = this;
        try {
            var hWidget = me.myRoot.height();
            var hTopmenu = me.myHtml.topmenu.outerHeight(true);
            var hContent = hWidget - hTopmenu - 4; // 4 for padding/margin

            // set content height
            me.myHtml.content.css("height", hContent + "px");

        } catch (e) { me.writeError('_setHeights', e); return false; }
    },

    _toggleMenuButtons: function (mode) {
        /// <summary>
        /// This function toggles the top menu buttons between list and day view modes.
        /// </summary>
        var me = this;
        try {
            if (mode !== "list" && mode !== "dayview") return;

            me.myHtml.topmenu.find("#btn-dayview").toggleClass("button-toggle-active", mode === "dayview");
            me.myHtml.topmenu.find("#btn-list").toggleClass("button-toggle-active", mode === "list");

            me.myStatus.selectedMode = mode;
            me.myStatus.interval = (mode === "dayview") ? 1 : 3;

            switch (mode) {
                case "list":                    
                    me.myHtml.activityList.show();
                    me.myHtml.activityDayview.hide();
                    me.myHtml.activityEdit.hide();
                    objActivityList._generateList(me);
                    break;
                case "dayview": 
                    me.myHtml.activityList.hide();
                    me.myHtml.activityDayview.show();
                    me.myHtml.activityEdit.hide();
                    objActivityDayView._generateDayview(me);
                    break;
            }            

        } catch (e) { me._writeErr(e); }

    },

    _openTicketFromActivity: function (ticketId, blid) {
        /// <summary>
        /// This function opens a ticket dialog in read-only mode based on the provided ticket ID and logger ID.
        /// </summary>
        var me = this;
        try {
            ticketId = parseInt(ticketId, 10);
            blid = parseInt(blid, 10);

            if (!ticketId || isNaN(ticketId) || ticketId <= 0) return;
            if (!blid || isNaN(blid) || blid <= 0) return;

            me.vcV.showSingleTicketDialog(blid, {
                TicketID: ticketId,
                LoggerID: blid,
                readOnlyMode: true,
                startEntry: null
            });
        } catch (e) {
            me._writeErr(e);
        }
    },

    

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) { }
            return true;
        } catch (e) { me.writeError('specificInfoHandling', e); return false; }
    }


});


